import { createStyles, makeStyles } from '@material-ui/core/styles';

interface StyleProps {
  isMobile: boolean;
}

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      flexGrow: 1,
      flexDirection: 'column',
      background: 'none',
    },
    dots: {
      alignItems: 'center',
      margin: '5px 0',
    },
    dot: {
      margin: '0 10px',
    },
    dotActive: {
      backgroundColor: '#2D6DF6',
      width: '12px',
      height: '12px',
    },
    divHeader: {
      display: 'flex',
      justifyContent: ({ isMobile }: StyleProps) => (isMobile ? 'flex-end' : 'center'),
      alignItems: 'center',
      width: ({ isMobile }: StyleProps) => (isMobile ? '100%' : '668px'),
    },
    divBack: {
      display: 'flex',
      justifyContent: ({ isMobile }: StyleProps) => (isMobile ? 'center' : 'flex-start'),
    },
    divStepper: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
    },
    gridStepper: {
      position: 'absolute',
      left: ({ isMobile }: StyleProps) => (isMobile ? '50%' : '35%'),
      transform: 'translateX(-50%)',
    },
    divBackSubscription: {
      display: 'flex',
    },
    divStep: {
      display: 'flex',
    },
    arrowBackIcon: {
      width: '24px',
      height: '24px',
      color: '#2D6DF6',
    },
    labelBack: {
      color: '#2D6DF6',
      fontSize: '16px',
      fontFamily: 'SuraSans-Seminegrita',
      paddingLeft: '20px',
      '&:hover': {
        background: 'none',
        textTransform: 'none',
      },
    },
    labelBackSubscription: {
      color: '#2D6DF6',
      fontSize: '16px',
      fontFamily: 'SuraSans-Seminegrita',
      paddingLeft: '20px',
      '&:hover': {
        background: 'none',
        textTransform: 'none',
      },
    },
    labelBackSubscriptionText: {
      fontFamily: 'SuraSans-Extranegrita',
    },
    labelDomiciliacion: {
      fontFamily: 'SuraSans-Regular',
      fontSize: '16px',
      color: '#000000',
    },
    labelExtraBold: {
      fontFamily: 'SuraSans-Extranegrita',
    },
    divider: {
      margin: '15px 0 !important',
      width: ({ isMobile }: StyleProps) => (isMobile ? '100%' : '670px'),
    },
    labelPayment: {
      fontFamily: 'SuraSans-Negrita',
      fontSize: '26px',
      color: '#000000',
    },
    divCards: {
      display: 'flex',
      marginTop: '20px',
      marginLeft: ({ isMobile }: StyleProps) => (isMobile ? '0' : '-12px'),
      width: '100%',
    },
    payButton: {
      width: '78px',
      height: '40px',
      color: '#0133A0',
      borderRadius: '28px',
      background: '#E3E828',
      fontFamily: 'SuraSans-Seminegrita',
      fontSize: '16px',
      padding: '10px',
      '&:hover': {
        background: '#E3E828',
        textTransform: 'none',
      },
      '& > span > div > svg': {
        color: '#2D6DF6 !important',
      },
    },
    progress: {
      color: '#FFFFFF',
    },
    gridContent: {
      display: 'flex',
      justifyContent: 'center',
    },
  }),
);

export default useStyles;
